var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rma-pending-table',{attrs:{"returns":_vm.returns,"approved":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dafd72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/rma-hc/RmaPendingReceive.vue
// module id = null
// module chunks = 